<template>
  <div class="border-b">
    <SfAccordionItem class="select-none" v-model="isOpen">
      <template #summary>
        <div class="flex justify-between pb-2">
          <p class="text-gray-700">{{ t('If you have a voucher or a coupon code click here and it add it below') }}</p>
          <SfIconChevronLeft :class="['text-neutral-500', { 'rotate-90': isOpen, '-rotate-90': !isOpen }]" />
        </div>
      </template>
      <div class="flex items-center gap-3">
        <input v-model="couponCode" class="form-input" :readonly="Boolean(defaultCoupon)"
          :placeholder="defaultCoupon ? defaultCoupon.code : t('Type your promo code here')"
          :class="{ 'pointer-events-none': defaultCoupon }" />
        <VButton v-if="!defaultCoupon" @click="applyCouponAndUpdate">
          {{ t('Apply') }}
        </VButton>
        <VButton v-else @click="removeCouponAndUpdate" variant="secondary">
          {{ t("Remove") }}
        </VButton>
      </div>
    </SfAccordionItem>
    <Alert v-if="errors.length" class="mt-4">
      <p v-for="error in errors" :key="error">{{ error }}</p>
    </Alert>
  </div>
  <div class="mt-2">
    <div v-for="added in cart?.vouchers.added" class="bg-green-100 rounded p-2 text-green-800">
      {{ t('Voucher successfully applied') }}: {{ added.name }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { SfIconChevronLeft, SfAccordionItem } from '@storefront-ui/vue';
import useNotifications from '~/stores/notifications';

const { t } = useI18n();

const { data: cart, applyCoupon, errors, removeCoupon } = useCart();
const isOpen = ref(false);
const couponCode = ref('')

const defaultCoupon = computed(() => {
  let activatedCoupon = null
  if (cart.value) {
    if (Object.keys(cart.value.vouchers.added).length) {
      activatedCoupon = (cart.value?.vouchers.added as any)[Object.keys(cart.value.vouchers.added)[0]!]
    }
  }
  return activatedCoupon
})

const applyCouponAndUpdate = async () => {
  applyCoupon({
    addDiscount: 1,
    discount_name: couponCode.value,
  });
}

const removeCouponAndUpdate = async () => {
  removeCoupon({
    deleteDiscount: defaultCoupon.value.id_cart_rule,
  });
}

</script>
